"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Label = void 0;
const tslib_1 = require("tslib");
const styled_1 = tslib_1.__importDefault(require("@emotion/styled"));
const styled_tools_1 = require("styled-tools");
const Box_1 = require("./Box");
exports.Label = styled_1.default(Box_1.Box.withComponent('label')) `
  display: inline-block;
  ${styled_tools_1.theme('Label')};
`;

//# sourceMappingURL=Label.js.map
